<template>
  <div class="phoneShop">
    <div class="phoneBox">
      <div class="phone">
        <div class="bangs">
          <div></div>
          <div></div>
        </div>
        <div class="view">
          <div class="list">
            <p>BRAVODRESS</p>
            <div class="row">
              <span>Your cart</span>
              <span>1 items</span>
            </div>
            <div class="line"></div>
            <div class="item">
              <img src="@/assets/images/Client/item.png">
              <div class="info">
                <p class="font">GLOW UP SATIN WRAP DRESS – OFF WHITE</p>
                <div>
                  <div>
                    <span>-</span>
                    <span>1</span>
                    <span>+</span>
                  </div>
                  <p class="font">$422.10</p>
                </div>
              </div>
            </div>
            <div class="row">
              <span style="font-weight: bold; color: #000000">Total</span>
              <span style="font-weight: 500">$422.10</span>
            </div>
            <div class="line" style="margin-top: 9px"></div>
          </div>

          <div class="pay" ref="paybtn">
            <img src="@/assets/images/Client/pay.png">
          </div>
          <div class="checkOut">CHECKOUT</div>

          <div class="mask" ref="mask" :style="`opacity: ${showPayInfo ? 0.2 : 0}`"></div>
          <div class="payInfo" ref="payInfo" :style="`bottom: ${showPayInfo ? '4px' : '-380px'}`">
            <img src="@/assets/images/Client/payInfo.png">
            <div class="payStatus">
              <img ref="faceBorder" src="@/assets/images/Client/faceBorder.png">
              <img ref="face" src="@/assets/images/Client/face.png">
              <div class="circle">
                <div ref="circle"></div>
                <div ref="circle2"></div>
                <div ref="circle3"></div>
                <div ref="circle4"></div>
                <div ref="circle5"></div>
              </div>

              <div class="svgAni">
                <svg width="28" height="28">
                  <polyline class="tickAni" ref="svg_tick" fill="none" stroke="#007AFF" stroke-width="2" points="7,14 12.4,18 20.8,9" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import base from '../base'
  import tween from '@tweenjs/tween.js'
  export default {
    extends: base,
    name: "index",
    data() {
      return {
        showPayInfo: false,
        rafId: null,
      }
    },
    mounted() {

      let animate = () => {
        this.rafId = requestAnimationFrame(animate);
        tween.update();
      }
      animate();

      this.reset();
    },

    methods: {
      animation() {
        this.$refs.payInfo.style.opacity = 1;

        this.$refs.paybtn.style.transform = "scale(" + 0.9 + ")";
        this.setTimeOut(() => {
          this.$refs.paybtn.style.transform = "scale(" + 1 + ")";
        },200);

        this.setTimeOut(() => {
          this.showPayInfo = true;
          let speed = 400;
          this.setTimeOut(() => {
            this.$refs.faceBorder.style.opacity = 0;
            let act_1 = new tween.Tween({ x1: 1 , x2: 1, opacity: 0 , rotate2: -45 , rotate3: -45 , rotate4: -45,rotate5: -45}).to({ x1: -0.2 , x2: -1, opacity: 0.8, rotate2: 90 , rotate3: 135 , rotate4: 180, rotate5: 225 }, speed).onUpdate(t => {
              if(this.$refs.circle){
                for(let i = 2 ; i < 6 ; i++) {
                  this.$refs['circle'+i].style.transform = "rotate("+ t['rotate'+i] +"deg) scaleX(" + (i == 2 || i == 4 ? t.x2 : t.x1) +")";
                  this.$refs['circle'+i].style.opacity = t.opacity;
                  this.$refs.face.style.opacity = 1 - t.opacity*1.2;
                }
              }
            });

            let act_2 = new tween.Tween({opacity: 1}).to({ opacity: 0}, speed/2).onUpdate(t => {
              if(this.$refs.circle){
                for(let i = 2 ; i < 6 ; i++) {
                  this.$refs['circle'+i].style.opacity = t.opacity;
                }
              }
            })
            act_1.chain(act_2);
            act_1.start();
          },1950);

          this.setTimeOut(() => {
            let act1 = new tween.Tween({ number: 1 , rotate: -45}).to({ number: -1 , rotate: 45}, speed).easing(tween.Easing.Quadratic.InOut).onUpdate(t => {
              if(this.$refs.circle){
                this.$refs.circle.style.transform = "rotate("+ t.rotate +"deg) scaleX(" + t.number +")";
                this.$refs.circle.style.opacity = t.number;
              }
            })

            let act2 = new tween.Tween({ number: -1 , rotate: 45 }).to({ number: 1 , rotate: -45 }, speed).onUpdate(t => {
              if(this.$refs.circle){
                this.$refs.circle.style.transform = "rotate(" + t.rotate + "deg) scaleX(" + t.number +")";
                this.$refs.circle.style.opacity = Math.abs(t.number);
              }
            })

            act1.chain(act2);
            act1.start();
            this.$refs.svg_tick?.setAttribute("class", "tickAni tickPlay");
          },2000);

          this.setTimeOut(() => {
            this.reset();
          },7000);

        },500);
      },
      reset () {
        this.$refs.mask.style.opacity = 0;
        this.$refs.payInfo.style.opacity = 0;
        this.setTimeOut(() => {
          this.showPayInfo = false;
          this.$refs.svg_tick.setAttribute("class", "tickAni tickRevert");
          this.$refs.face.style.opacity = 1;
          this.$refs.faceBorder.style.opacity = 1;
          this.$refs.circle.style.opacity = 0;

          this.setTimeOut(() => {
            this.animation();
          },1000);
        }, 500);
      }
    },
    destroyed() {
      cancelAnimationFrame(this.rafId);
    }
  }
</script>

<style lang="less" scoped>
  .phoneBox {
    width: 298px;
    padding: 8px;
    background: #FFFFFF;
    box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
    border-radius: 36px;

    .phone {
      position: relative;
      padding: 43px 24px 24px 24px;
      border-radius: 30px;
      overflow: hidden;

      .bangs {
        position: absolute;
        background: #FFFFFF;
        width: 150px;
        height: 40px;
        border-radius: 40px;
        top: -15px;
        left: 66px;

        & > div {
          position: absolute;
          background: #F5F8FB;
          left: 60px;
          bottom: 12px;
          width: 30px;
          height: 5px;
          border-radius: 3px;
          border: 1px solid #E9EEF3;

          &:last-child {
            left: 100px;
            width: 5px;
            height: 5px;
          }
        }
      }

      .view {
        .list {
          padding: 0 9px;
          & > p {
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #082442;
            line-height: 20px;
          }

          .row {
            margin-top: 16px;
            display: flex;
            justify-content: space-between;
            & > span {
              font-size: 14px;
              color: #2E4157;
              line-height: 16px;
            }
          }

          .line {
            margin-top: 26px;
            height: 1px;
            background: #ADB8C5;
          }

          .item {
            display: flex;
            margin-top: 27px;
            margin-bottom: 227px;
            & > img {
              height: 70px;
            }
            .info {
              .font {
                text-align: right;
                font-size: 12px;
                font-weight: 500;
                color: #2E4157;
                line-height: 15px;
              }

              & > div {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 0 0 12px;
                & > div {
                  display: flex;
                  justify-content: space-between;
                  width: 68px;
                  padding: 4px 12px;
                  border: 1px solid #2E4157;
                  & > span {
                    line-height: 17px;
                  }
                }
              }
            }
          }
        }

        .pay {
          margin-top: 23px;
          padding: 7px 90px;
          background: #0070FF;
          border-radius: 17px;
          transition: all 0.2s;
          & > img {
            height: 19px;
          }
        }

        .checkOut {
          margin-top: 10px;
          padding: 7px 78px;
          border-radius: 17px;
          border: 1px solid #0070FF;
          font-weight: 500;
          color: #0070FF;
          font-size: 14px;
          line-height: 20px;
        }

        .mask {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: #0b3055;
          border-radius: 30px;
          opacity: 0;
          transition: all 0.6s;
        }

        .payInfo {
          display: flex;
          position: absolute;
          bottom: -380px;
          left: 4px;
          transition: all 0.6s ease-in-out;
          & > img {
            height: 373px;
          }

          .payStatus {
            position: absolute;
            bottom: 25px;
            left: 121px;

            .circle {
              position: relative;
              & > div {
                position: absolute;
                top: 0;
                width: 32px;
                height: 32px;
                border: #8cc3ff solid 2px;
                border-radius: 16px;
                opacity: 0;
                &:first-child {
                  position: static;
                  border: #007AFF solid 2px;
                }
              }
            }

            & > img {
              position: absolute;
              width: 32px;
              &:nth-child(2) {
                margin: 5px;
                width: 22px;
              }
            }
          }
        }
      }
    }


    .svgAni {
      position: absolute;
      top: 3px;
      left: 2px;
      display: flex;

      .tickAni {
        stroke-dasharray: 45;
        stroke-dashoffset: 45;
      }

      .tickPlay {
        animation: tickRun 0.8s ease-out forwards;
        animation-delay: 0.6s;
      }
      .tickRevert {
        animation: tickRevert 0 forwards;
      }

      @keyframes tickRun {
        form {
          stroke-dashoffset: 45;
        }
        to {
          stroke-dashoffset: 0;
        }
      }
      @keyframes tickRevert {
        form {
          stroke-dashoffset: 0;
        }
        to {
          stroke-dashoffset: 45;
        }
      }
    }
  }
</style>
